/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Rename_ErrorInputs */

const vi_irrigation_rename_error = /** @type {(inputs: Irrigation_Rename_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đổi được tên trạm`)
};

/**

* @param {Irrigation_Rename_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_rename_error = /** @type {((inputs?: Irrigation_Rename_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Rename_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_rename_error(inputs)
});